@let anomalies = recordAnomaliesSg();
@let comment = recordCommentSg();
@let isRecordLoading = isRecordLoadingSg();

<atn-ds-widget title="General">
  @if (!isReadonlySg()) {
    <button
      actions
      class="atn-record-general__action-button"
      [disabled]="isRecordLoading"
      (click)="editClickHandler()"
    >
      <i class="atn-icon atn-edit atn-blue"></i>
    </button>
  }

  @if (
    recordsEc.plugins.currentEntityPlugin.feature.selectors
      .getEntity()
      .asSignal()
  ) {
    <div class="atn-record-general__section">
      @for (ancestor of recordAncestorsSg(); track $index) {
        <div class="atn-record-general__field">
          <span
            ><b>{{ ancestor.name }}</b></span
          >
          <atn-ds-value [value]="ancestor.value" />
        </div>
      }

      <div class="atn-record-general__field">
        <span><b>Room</b></span>
        <atn-ds-value [value]="recordNameSg()" />
      </div>

      <div class="atn-record-general__field">
        <span><b>Area (sqft)</b></span>
        <atn-ds-value [value]="recordAreaSg()" />
      </div>

      <div class="atn-record-general__field">
        <span><b>Room Type</b></span>
        <atn-ds-value [value]="roomTypeSg()" />
      </div>

      <div class="atn-record-general__field">
        <span><b>Room Category</b></span>
        <atn-ds-value [value]="roomCategorySg()" />
      </div>

      <div class="atn-record-general__field atn-record-general__full-width">
        <span><b>Description</b></span>
        <atn-ds-value [value]="recordDescriptionSg()" />
      </div>

      <!-- Comment  -->
      @if (comment) {
        <div
          class="atn-record-general__field atn-record-general__full-width"
        >
          <span><b>Comment</b></span>
          <atn-ds-value [value]="comment" />
        </div>
      }

      <!-- Anomalies  -->
      @if (anomalies.length > 0) {
        <div
          class="atn-record-general__field atn-record-general__full-width"
        >
          <span><b>Anomalies</b></span>
          <div class="atn-record-general__list">
            @for (anomaly of anomalies; track anomaly) {
              <div class="atn-record-general__item">
                {{ anomaly }}
              </div>
            }
          </div>
        </div>
      }
    </div>
  } @else if (isRecordLoading) {
    <div class="atn-record-general__loader">
      <atn-ds-loader />
    </div>
  }
</atn-ds-widget>

<atn-space-room-data-modal />
